import {
    FETCH_PRODUCTS_TO_COMPARE_BEGIN,
    FETCH_PRODUCTS_TO_COMPARE_SUCCESS,
    FETCH_PRODUCTS_TO_COMPARE_FAILURE,
    RESET_PRODUCTS_TO_COMPARE
} from '../constants/productsToCompareActionTypes';

const initialState = {
    productsToCompareList: {},
    isLoading: true,
    error: {}
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_PRODUCTS_TO_COMPARE_BEGIN:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_PRODUCTS_TO_COMPARE_SUCCESS:            
            return {
                ...state,
                productsToCompareList: action.payload,
                isLoading: false,
            };
        case FETCH_PRODUCTS_TO_COMPARE_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case RESET_PRODUCTS_TO_COMPARE:
            return {
                ...state,
                productsToCompareList: {},
                isLoading: true
            }
        default:
            return state;
    }
}
